
































































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator';
import HexabaseApi from '@/services/hexabase/hexabaseApi';
import hexabaseState from '@/store/hexabase';
import authState from '@/store/auth';
import userState from '@/store/user';

@Component({})
export default class Signin extends Vue {
  private hexabaseApi = new HexabaseApi();
  private email = '';
  private password = '';
  private errorMess = '';
  private show1 = false;

  private onkeyDownPassword(event: KeyboardEvent) {
    // Enter入力以外のイベントを無視する
    if (event.code !== 'Enter') return;
    // Enter入力の場合はログイン処理を呼び出す
    this.signin();
  }

  private async signin() {
    this.errorMess = '';
    try {
      // this.$store.commit('common/setLoading', true);
      // Authトークンの取得
      const token = await this.hexabaseApi.login(this.email, this.password);
      // Hexalink UserInfoの取得
      const userInfo = await this.hexabaseApi.getUserInfo(token);
      // workspaceの取得
      const workspaces = await this.hexabaseApi.getWorkspaces(token);
      const workspaceId = this.getWorkSpaceId(workspaces);

      // applicationの取得
      const applications = await this.hexabaseApi.getApplications(token, workspaceId);
      const targetApplication = applications.find(function(v: any) {
        if (v['name'] === (window as any).env.VUE_APP_HEXABASE_APP_NAME) {
          return v;
        }
      });

      const applicationId = targetApplication !== undefined ? targetApplication.application_id : applications[0].application_id;
      const datastores = targetApplication !== undefined ? targetApplication.datastores : applications[0].datastores;

      const datastoreIds: any = {};
      if (datastores)
        datastores.forEach((datastore: any) => {
          datastoreIds[datastore.name] = datastore.datastore_id;
        });

      // ユーザ名の取得
      const userName = userInfo.data.username;
      // 認証トークンをセット
      authState.setToken(token);
      // HexabaseアプリケーションIDをセット
      hexabaseState.setApplicationId(applicationId);
      // HexabasedatastoreIds（データストア一覧）をセット
      hexabaseState.setDatastoreIds(datastoreIds);
      // ユーザ名をセット
      userState.setUserName(userName);
      // メールアドレスをセット
      userState.setUserEmail(userInfo.data.email);
      // ログイン後画面に遷移 redirectがある場合はリダイレクト先に遷移、ない場合は工事案件管理へ遷移
      if (this.$route.query.redirect) {
        this.$router.push(String(this.$route.query.redirect));
      } else {
        this.$router.push({ name: 'ConstructionList'});
      }
    } catch (e) {
      this.errorMess = 'メールアドレスもしくはパスワードが違います。';
    } finally {
      // this.$store.commit('common/setLoading', false);
    }
  }

  getWorkSpaceId(workspaces: Array<any>) {
    let result = '';
    console.log((window as any).env.VUE_APP_HEXABASE_WORKSPACE_NAME)
    workspaces.forEach(item => {
      if (item['workspace_name'] === (window as any).env.VUE_APP_HEXABASE_WORKSPACE_NAME) {
        result = item['workspace_id'];
      }
    });
    return result;
  }
}
